import { api } from "@/services/api";
import getAllPlans from "./get-all-plans";
import getCurrentPlan from "./get-current-plan";
import getInvoices from "./get-invoices";
import prorateSubscription from "./prorate-subscription";
import updateSubscriptionCheckout from "./update-subscription";
import createCheckoutSession from "@/store/checkout/endpoints/create-checkout-session.ts";

export const checkoutApi = api.injectEndpoints({
  endpoints: build => ({
    getAllPlans: getAllPlans(build),
    getCurrentPlan: getCurrentPlan(build),
    getInvoices: getInvoices(build),
    prorateSubscription: prorateSubscription(build),
    updateSubscription: updateSubscriptionCheckout(build),
    createCheckoutSession: createCheckoutSession(build),
  }),
});

export const {
  useGetAllPlansQuery,
  useGetCurrentPlanQuery,
  useGetInvoicesQuery,
  useLazyProrateSubscriptionQuery,
  useUpdateSubscriptionMutation,
} = checkoutApi;
